// A second factor for TPRM's own passwords (release 3.1): a signed-in
// person's own setup, an administrator's reset for a lost phone, and the
// tenant's switch that requires one of administrators. The step between a
// right password and a session is on the sign-in screen (views/SignIn.tsx),
// which has no session and calls the API directly.

import { request } from './api'

export type MyMFA = {
  available: boolean
  why?: string
  passwordAllowed?: boolean
  enrolled?: boolean
  required?: boolean
  confirmedAt?: string
  recoveryCodesLeft?: number
}

export type MFAEnrolment = {
  secret: string
  otpauthUri: string
  qrPng: string
  issuer: string
  account: string
  note: string
}

export type SignInSecurity = { requireMfaForAdmins: boolean; applies: boolean; note: string }

const post = <T>(path: string, body?: unknown) =>
  request<T>(path, { method: 'POST', body: body === undefined ? undefined : JSON.stringify(body) })

export const mfaApi = {
  mine: () => request<MyMFA>('/v1/me/mfa'),
  enrol: () => post<MFAEnrolment>('/v1/me/mfa/enrol'),
  confirm: (code: string) => post<{ enrolled: boolean; recoveryCodes: string[]; note: string }>('/v1/me/mfa/confirm', { code }),
  newRecoveryCodes: (code: string) => post<{ recoveryCodes: string[] }>('/v1/me/mfa/recovery-codes', { code }),
  disable: (code: string) => post<{ enrolled: boolean }>('/v1/me/mfa/disable', { code }),
  resetFor: (subject: string) =>
    post<{ removed: boolean; sessionsEnded: number; note: string }>('/v1/users/' + encodeURIComponent(subject) + '/mfa/reset'),
  signInSecurity: () => request<SignInSecurity>('/v1/settings/sign-in-security'),
  setSignInSecurity: (requireMfaForAdmins: boolean) =>
    request<{ requireMfaForAdmins: boolean }>('/v1/settings/sign-in-security', {
      method: 'PUT',
      body: JSON.stringify({ requireMfaForAdmins }),
    }),
}
